'use client';
import * as React from 'react';
import { getVideoCompletionPercentage } from '../../utils/return-video-completion-percentage';
import { Typography } from '@mui/material';
import { ICourseData } from '../../types/course-data';

interface ProgressBarProps {
  lessons: ICourseData['lessons'];
}
const ProgressBar: React.FC<ProgressBarProps> = ({ lessons }) => {
  const summedLessonsDuration =
    lessons?.reduce((acc, curr) => {
      if (!curr?.duration) return acc;
      return acc + (curr?.duration || 0);
    }, 0) || 0;

  const summedLessonsProgress =
    lessons?.reduce((acc, curr) => {
      if (curr?.lessonProgresses?.[0]?.progress_status === 'completed')
        return acc + (curr?.duration || 0);
      return acc + (curr?.lessonProgresses?.[0]?.current_second || 0);
    }, 0) || 0;

  const completionPercentage =
    summedLessonsProgress > 0
      ? getVideoCompletionPercentage(summedLessonsDuration, summedLessonsProgress)
      : 0;

  return (
    <>
      <Typography variant="s2" component="p" className="text-text-secondary">
        Completato
      </Typography>
      <div className="flex flex-row gap-2">
        <div className="flex flex-col self-stretch my-auto w-40 rounded-none">
          <div className="flex flex-col items-start rounded-2xl bg-neutral-main max-md:pr-5 overflow-hidden">
            <div
              className="flex shrink-0 h-4 bg-primary-main rounded-lg"
              style={{ width: `${completionPercentage}%` }}
            />
          </div>
        </div>
        <div className="self-stretch my-auto text-base font-semibold text-zinc-200">
          {completionPercentage}%
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
